<template>
    <div class="vertical-nav-container">
        <Transition name="fade-right">
        <div class="vertical-nav" v-if="showMenu" @click="closeMenu">

        <nav class="vertical-menu">
            <button class="close" @click="scloseMenu">+</button>
            <div class="logo">
                <a href="/">
                    <img src="../assets/images/logo.png" alt="">
                </a>
            </div>
            
            
            <ul class="vertical-nav-list user" v-if="getUser">
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'UserAccount'}">Кабінет</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'UsePaymentAccounts'}">- Мої рахунки</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'UserPayHistory'}">- Транзакції</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'UserCards'}">- Мої групи</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'InvitesList'}">- Запрошення в групу</router-link>
                </li>
            </ul>

             <ul class="vertical-nav-list">
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'AboutUs' }">Про нас</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'Contacts'}">Контакти</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{ name: 'Bonuses'}">Промо акції</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{name: 'Political'}" >Політика конфіденційності</router-link>
                </li>
                <li class="vertical-nav-item">
                     <router-link :to="{name: 'Offers'}" >Публічна оферта</router-link>
                </li>
            </ul>
           
            <div class="contacts row">
                 <p class="title"><strong>Контакти</strong></p>
                <a href="tel:380505923772">+38 050 592 3772</a>
                <a href="mailto:info@samwash.tech">info@samwash.tech</a>
            </div>
            <ul class="social-media row">
                <li>
                    <a href="https://www.facebook.com/samwashcarwash" target="_blank">
                        <span class="icon">
                            <svg viewBox="0 0 48 48" width="48px" height="48px"><path fill="#fff" d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"/><path fill="#cd2224" d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"/></svg>
                        </span>
                        facebook</a>
                </li>
                <li>
                    <a href="https://www.instagram.com/samwash_carwash/" target="_blank">
                         <span class="icon">
                            <svg viewBox="0 0 48 48" width="48px" height="48px"><radialGradient id="yOrnnhliCrdS2gy~4tD8ma" cx="19.38" cy="42.035" r="44.899" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset=".328" stop-color="#fff"/><stop offset=".348" stop-color="#fff"/><stop offset=".504" stop-color="#fff"/><stop offset=".643" stop-color="#fff"/><stop offset=".761" stop-color="#fff"/><stop offset=".841" stop-color="#fff"/></radialGradient><path fill="url(#yOrnnhliCrdS2gy~4tD8ma)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20 c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20 C42.014,38.383,38.417,41.986,34.017,41.99z"/><radialGradient id="yOrnnhliCrdS2gy~4tD8mb" cx="11.786" cy="5.54" r="29.813" gradientTransform="matrix(1 0 0 .6663 0 1.849)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset=".999" stop-color="#fff" stop-opacity="0"/></radialGradient><path fill="url(#yOrnnhliCrdS2gy~4tD8mb)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20 c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20 C42.014,38.383,38.417,41.986,34.017,41.99z"/><path fill="#cd2224" d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5 s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"/><circle cx="31.5" cy="16.5" r="1.5" fill="#cd2224"/><path fill="#cd2224" d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12 C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"/></svg>
                        </span>
                        Instagram</a>
                </li>
                <li>
                    <a href="https://www.tiktok.com/@samwash.official" target="_blank">
                         <span class="icon">
                            <svg viewBox="0 0 48 48" width="48px" height="48px" fill-rule="evenodd" clip-rule="evenodd"><path fill="#fff" fill-rule="evenodd" d="M10.904,6h26.191C39.804,6,42,8.196,42,10.904v26.191 C42,39.804,39.804,42,37.096,42H10.904C8.196,42,6,39.804,6,37.096V10.904C6,8.196,8.196,6,10.904,6z" clip-rule="evenodd"/><path fill="#fff" fill-rule="evenodd" d="M29.208,20.607c1.576,1.126,3.507,1.788,5.592,1.788v-4.011 c-0.395,0-0.788-0.041-1.174-0.123v3.157c-2.085,0-4.015-0.663-5.592-1.788v8.184c0,4.094-3.321,7.413-7.417,7.413 c-1.528,0-2.949-0.462-4.129-1.254c1.347,1.376,3.225,2.23,5.303,2.23c4.096,0,7.417-3.319,7.417-7.413L29.208,20.607L29.208,20.607 z M30.657,16.561c-0.805-0.879-1.334-2.016-1.449-3.273v-0.516h-1.113C28.375,14.369,29.331,15.734,30.657,16.561L30.657,16.561z M19.079,30.832c-0.45-0.59-0.693-1.311-0.692-2.053c0-1.873,1.519-3.391,3.393-3.391c0.349,0,0.696,0.053,1.029,0.159v-4.1 c-0.389-0.053-0.781-0.076-1.174-0.068v3.191c-0.333-0.106-0.68-0.159-1.03-0.159c-1.874,0-3.393,1.518-3.393,3.391 C17.213,29.127,17.972,30.274,19.079,30.832z" clip-rule="evenodd"/><path fill="#cd2224" fill-rule="evenodd" d="M28.034,19.63c1.576,1.126,3.507,1.788,5.592,1.788v-3.157 c-1.164-0.248-2.194-0.856-2.969-1.701c-1.326-0.827-2.281-2.191-2.561-3.788h-2.923v16.018c-0.007,1.867-1.523,3.379-3.393,3.379 c-1.102,0-2.081-0.525-2.701-1.338c-1.107-0.558-1.866-1.705-1.866-3.029c0-1.873,1.519-3.391,3.393-3.391 c0.359,0,0.705,0.056,1.03,0.159V21.38c-4.024,0.083-7.26,3.369-7.26,7.411c0,2.018,0.806,3.847,2.114,5.183 c1.18,0.792,2.601,1.254,4.129,1.254c4.096,0,7.417-3.319,7.417-7.413L28.034,19.63L28.034,19.63z" clip-rule="evenodd"/><path fill="#cd2224" fill-rule="#fff" d="M33.626,18.262v-0.854c-1.05,0.002-2.078-0.292-2.969-0.848 C31.445,17.423,32.483,18.018,33.626,18.262z M28.095,12.772c-0.027-0.153-0.047-0.306-0.061-0.461v-0.516h-4.036v16.019 c-0.006,1.867-1.523,3.379-3.393,3.379c-0.549,0-1.067-0.13-1.526-0.362c0.62,0.813,1.599,1.338,2.701,1.338 c1.87,0,3.386-1.512,3.393-3.379V12.772H28.095z M21.635,21.38v-0.909c-0.337-0.046-0.677-0.069-1.018-0.069 c-4.097,0-7.417,3.319-7.417,7.413c0,2.567,1.305,4.829,3.288,6.159c-1.308-1.336-2.114-3.165-2.114-5.183 C14.374,24.749,17.611,21.463,21.635,21.38z" clip-rule="evenodd"/></svg>
                        </span>
                        TikTok</a>
                </li>
                <li>
                    <a href="https://www.youtube.com/@samwash" target="_blank">
                         <span class="icon">
                            <svg viewBox="0 0 48 48" width="48px" height="48px"><path fill="#fff" d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"/><path fill="#cd2224" d="M20 31L20 17 32 24z"/></svg>
                        </span>
                        YouTube</a>
                </li>
            </ul>
            
        </nav>
        
    </div>
    </Transition>
    <button v-if="!showMenu" @click="openMenu" class="menu-btn">
        <div class="burger">
                <span></span>
                <span></span>
                <span></span>
            </div>
    </button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showMenu: false
        }
    },
    computed:{
        getUser(){
            return this.$store.getters.getUser;
        },
    },
    watch: {
        $route(to, from) {
            if(from && to) {
                this.showMenu = false
                document.documentElement.style.overflow = 'auto';
            }
        }
    },
    methods: {

        openMenu() {
            this.showMenu = true
             document.documentElement.style.overflow =  'hidden';
        },
        closeMenu(event) {
           if(event.target.classList.contains('vertical-nav')) {
                this.showMenu = false
                document.documentElement.style.overflow = 'auto';
                return
           }

           if(event.target.classList.contains('close')) {
                this.showMenu = false
                document.documentElement.style.overflow = 'auto';
                return
           }
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "src/assets/scss/vertical-menu.scss";
</style>